module.exports = {
  home: 'HOME',
  appproducts: 'APP PRODUCTS',
  helloworld: 'hello world',
  helloman: 'hello {name}',
  iphones: 'iphone5 | iphone6 | iphone7'
}
